<template>
  <div>
    <ValidationObserver ref="form">
      <form class="form" autocomplete="off">
        <div>
          <p>Bước 1: Tải file mẫu Excel</p>
          <el-button @click="exportExcelExample" type="warning" class="font-weight-bold mr-2 mb-3 text-dark">
            Xuất file mẫu
          </el-button>
        </div>
        <div>
          <p>Bước 2: Sau khi cập nhật dữ liệu trong file Excel, tiến hành tải lên hệ thống</p>
          <label class="btn btn-primary font-weight-bold mr-2">
            Upload file
            <input
                type="file"
                accept=".xlsx,.xls"
                hidden
                @change="handleFileChange"
                ref="myFileInput"
            />
          </label>
          <div class="mt-2" v-if="addFile">
            <span class="bg-da p-2 rounded">
              {{ files_prop.name }}
              <i class="el-icon-circle-close cursor-pointer ml-2" @click="closeFile" />
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <!-- Dialog Preview & Validate -->
    <el-dialog
        title="Kiểm tra dữ liệu trước khi import"
        :visible.sync="showValidationDialog"
        width="90%"
        append-to-body
    >
      <el-table
          :data="previewRows"
          style="width: 100%;"
          :row-class-name="rowClassName"
      >
        <el-table-column prop="Họ tên khách hàng" label="Họ tên khách hàng" />
        <el-table-column prop="Số điện thoại khách hàng" label="SĐT" />
        <el-table-column prop="Ngày sinh" label="Ngày sinh" />
        <el-table-column prop="Đối tượng" label="Đối tượng" />
        <el-table-column prop="Kênh" label="Kênh" />
        <el-table-column prop="Phím nóng" label="Phím nóng" />
        <el-table-column prop="Chi tiết phím nóng" label="Chi tiết phím nóng" />
        <el-table-column prop="Trường học" label="Trường học" />
        <el-table-column prop="Khách hàng của" label="Khách hàng của" />
        <el-table-column label="Lỗi" width="250">
          <template #default="{ row, $index }">
            <div v-if="rowErrors[$index]" class="text-danger">
              <div v-for="(err, i) in rowErrors[$index]" :key="i">{{ err }}</div>
            </div>
            <span v-else class="text-success">Đạt</span>
          </template>
        </el-table-column>
      </el-table>

      <template #footer>
        <el-button @click="showValidationDialog = false">Hủy</el-button>
        <el-button
            type="primary"
            :disabled="hasValidationErrors"
            :loading="loading"
            @click="importFile"
        >Import</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import {
  EXPORT_EXCEL_IMPORT_CUSTOMER,
  IMPORT_NOTE_CUSTOMER_EXCEL
} from '@/core/services/store/user/users.module';
import * as XLSX from 'xlsx';

export default {
  name: 'DialogImportNoteCustomer',
  components: { ValidationObserver },
  data() {
    return {
      files_prop: null,
      addFile: false,
      previewRows: [],
      rowErrors: {},
      showValidationDialog: false,
      loading: false,
    };
  },
  computed: {
    hasValidationErrors() {
      return Object.keys(this.rowErrors).length > 0;
    }
  },
  methods: {
    exportExcelExample() {
      this.$store.dispatch(EXPORT_EXCEL_IMPORT_CUSTOMER, {}).then((response) => {
      })
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.name.match(/\.(xlsx|xls)$/i)) {
        this.$message.error('Vui lòng chọn file Excel (.xlsx hoặc .xls)');
        this.closeFile();
        return;
      }
      this.files_prop = file;
      this.addFile = true;
      this.parseAndValidate(file);
    },
    async parseAndValidate(file) {
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data, {type: 'array'});
      const sheetName = wb.SheetNames[0];
      const json = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {defval: ''});

      this.previewRows = json;
      this.rowErrors = {};

      // Đếm số điện thoại để check trùng
      const phoneCounts = {};
      this.previewRows.forEach(row => {
        const phone = (row['Số điện thoại'] || '').toString().trim();
        if (phone) phoneCounts[phone] = (phoneCounts[phone] || 0) + 1;
      });

      this.previewRows.forEach((row, idx) => {
        const errs = [];
        const phone = (row['Số điện thoại khách hàng'] || '').toString().trim();
        const created_user = (row['Khách hàng của'] || '').toString().trim();

        if (!created_user) errs.push('Khách hàng của sale là bắt buộc');
          // Format check
          if (!/^0\d{9,10}$/.test(phone) && phone) {
            errs.push(`Số điện thoại ${phone} sai định dạng`);
          }
          // Duplicate check
          else if (phoneCounts[phone] > 1) {
            errs.push('Số điện thoại bị trùng');
          }
        if (errs.length) this.$set(this.rowErrors, idx, errs);
      });

      this.showValidationDialog = true;
    },
    rowClassName({rowIndex}) {
      return this.rowErrors[rowIndex] ? 'error-row' : '';
    },

    async importFile() {
      if (this.hasValidationErrors) return;
      if (!this.files_prop) {
        this.$message.error('Vui lòng chọn file để upload');
        return;
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.files_prop);
        await this.$store.dispatch(IMPORT_NOTE_CUSTOMER_EXCEL, formData);
        this.$message.success('Import dữ liệu thành công');
        this.close();
        this.$emit('close');
        this.$emit('reload');
      } catch {
        this.$message.error('Upload thất bại');
      } finally {
        this.loading = false;
      }
    },
    closeFile() {
      this.files_prop = null;
      this.showValidationDialog = false;
      this.addFile = false;
      this.$refs.myFileInput.value = '';
    },
    close() {
      this.$emit('close');
      this.closeFile();
    }
  }
};
</script>

<style scoped>
.error-row {
  background-color: #ffecec !important;
}

.text-success {
  color: #67c23a;
}

.text-danger {
  color: #f56c6c;
  font-weight: bold;
}
</style>
